<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Add-on management</h1>
    <addOnManage/>
  </v-card>
</template>

<script>
import addOnManage from "@/components/back-office/Messenger/Addon/AddonListTable";
export default {
  components: {
    addOnManage
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Messenger",
        disabled: false,
        href:
           "/weserve_admin_login/control/" + this.$route.params.province + "/messenger/addon"
      },
      {
        text: "Add-on Management",
        disabled: true,
        href:
           "/weserve_admin_login/control/" + this.$route.params.province + "/messenger/addon"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
